function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledProofsSectionComponent } from "./proofs-section-component.scss.js";
export default function ProofsSectionComponent(props) {
    const { proofs, backgroundImage } = props;
    return /*#__PURE__*/ _jsx(StyledProofsSectionComponent, {
        backgroundImage: backgroundImage,
        children: /*#__PURE__*/ _jsx("div", {
            className: "proofs-container",
            children: proofs === null || proofs === void 0 ? void 0 : proofs.map((proof, index)=>{
                return /*#__PURE__*/ _jsx("div", {
                    className: "proof",
                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, proof))
                }, index);
            })
        })
    });
}
